module.exports = __webpack_public_path__ + "assets/minus.d90e2cee.svg";